import React, { useState } from "react";
import PageShell from "../dashboard/PageShell";
import {
  OrganizationBasicInfo,
  OrganizationContactInfo,
  OrganizationFileUpload,
  OrganizationFormActions,
} from "../../components/forms/OrganizationForm";

interface AddNewOrganizationProps {}

const AddNewOrganization: React.FC<AddNewOrganizationProps> = () => {
  const [formData, setFormData] = useState({
    organizationName: "",
    englishName: "",
    classification: "",
    address: "",
    email: "",
    phone: "",
    country: "",
    contactPerson: "",
    contactPhone: "",
    contactEmail: "",
    notes: "",
    attachedFiles: [] as File[],
  });

  const handleInputChange = (field: string, value: string | File[]) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Saving organization data:", formData);
    // TODO: Implement save functionality
  };

  return (
    <PageShell title="Thêm mới tổ chức">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm mới tổ chức
          </h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <OrganizationBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <OrganizationContactInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <OrganizationFileUpload
              formData={formData}
              handleInputChange={handleInputChange}
            />
          </div>
        </div>

        <OrganizationFormActions
          onSave={handleSave}
          onCancel={() => window.history.back()}
        />
      </div>
    </PageShell>
  );
};

export default AddNewOrganization;
